module.exports = __webpack_public_path__ + "static/media/4z5_website_logo_sup_hkbu.f60b3b0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4z5_website_logo_sup_hkbu.jpg
// module id = 83
// module chunks = 0